import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as snpDashboardAPI from '../../api/PurchaseAPI/snpDashboardAPI';

export const fetchSNPDashboardSummary = createAsyncThunk(
    'snpDashboard/fetchSNPDashboardSummary',
    async ({ roleId, userId } = {}, { rejectWithValue }) => {
        try {
            const response = await snpDashboardAPI.getSNPDashboardSummary({ roleId, userId });
            return response?.Data || response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch SNP Dashboard Summary');
        }
    }
);

const initialState = {
    summary: null,
    loading: false,
    error: null,
};

const snpDashboardSlice = createSlice({
    name: 'snpDashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSNPDashboardSummary.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSNPDashboardSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.summary = action.payload;
            })
            .addCase(fetchSNPDashboardSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectSNPDashboardSummary = (state) => state.snpDashboard.summary;
export const selectSNPDashboardLoading = (state) => state.snpDashboard.loading;

export default snpDashboardSlice.reducer;
